var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagSelected = function SvgTagSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.02 9.981c0 .43.234 1.016.546 1.329l8.243 8.242c.742.742 1.953.742 2.656 0l7.969-7.969c.742-.703.742-1.914 0-2.656L11.19.685C10.88.372 10.293.099 9.863.099H1.895C.84.099.02.958.02 1.974zM4.395 2.6c1.015 0 1.875.859 1.875 1.875 0 1.054-.86 1.875-1.875 1.875A1.85 1.85 0 0 1 2.52 4.474c0-1.016.82-1.875 1.875-1.875"
  })));
};
export default SvgTagSelected;